import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Trash2, FolderTree, Plus } from "lucide-react";

export default function Categories() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/categories").then((r) => setItems(r.data));

  useEffect(() => {
    load();
  }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      await api.post("/categories", { name: name.trim() });
      setName("");
      toast.success("Kategori eklendi");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Ekleme başarısız");
    } finally {
      setSaving(false);
    }
  };

  const remove = async (c) => {
    if (!window.confirm(`"${c.name}" kategorisi silinsin mi?`)) return;
    try {
      await api.delete(`/categories/${c.id}`);
      toast.success("Kategori silindi");
      load();
    } catch (err) {
      toast.error("Silme başarısız");
    }
  };

  return (
    <div data-testid="categories-root">
      <div className="mb-6">
        <div className="font-mono-code text-[10px] tracking-[0.3em] text-stone-500">
          KATALOG
        </div>
        <h1 className="font-serif-display text-3xl sm:text-4xl text-stone-900">
          Kategoriler
        </h1>
        <p className="text-sm text-stone-500 mt-1">
          Ürünlerinizi düzenlemek için kategoriler tanımlayın.
        </p>
      </div>

      <form onSubmit={add} className="card-lux p-4 mb-6 flex gap-3">
        <input
          data-testid="new-category-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="flex-1 px-3 py-2 border border-stone-200 rounded-lg outline-none focus:border-amber-400"
          placeholder="Yeni kategori adı (örn: Set, Kravat İğnesi)"
        />
        <button
          data-testid="new-category-submit"
          disabled={saving}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg gold-gradient text-white text-sm disabled:opacity-60"
        >
          <Plus className="w-4 h-4" /> Kategori Ekle
        </button>
      </form>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((c) => (
          <div
            key={c.id}
            data-testid={`category-card-${c.name}`}
            className="card-lux p-4 flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-amber-50 border border-amber-200 flex items-center justify-center text-amber-700">
                <FolderTree className="w-4 h-4" />
              </div>
              <div>
                <div className="font-medium text-stone-900">{c.name}</div>
                <div className="text-[11px] text-stone-500 font-mono-code">
                  {c.id.slice(-6).toUpperCase()}
                </div>
              </div>
            </div>
            <button
              data-testid={`delete-category-${c.name}`}
              onClick={() => remove(c)}
              className="p-2 rounded-md border border-red-200 text-red-700 hover:bg-red-50"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
